/* Card gallery mobile swipe / dot nav — init once per page.
   Previously inlined in snippets/card-gallery.liquid, which rendered the same
   ~3 KB script once per card (10× on a PDP). Extracted here so Safari parses
   the body once instead of per instance. */
(function() {
  if (window.__vbCardGalleryInited) return;
  window.__vbCardGalleryInited = true;

  function initGallery(gallery) {
    if (gallery.closest('.resource-list__carousel')) return;

    if (gallery.dataset.dotsInit) return;
    gallery.dataset.dotsInit = 'true';

    if (window.innerWidth > 749) return;

    var dots = gallery.querySelectorAll('.card-gallery__dot');
    if (dots.length < 2) return;

    var slidesContainer = gallery.querySelector('slideshow-slides');
    if (!slidesContainer) return;

    var slides = slidesContainer.querySelectorAll('slideshow-slide');
    if (slides.length < 2) return;

    slides.forEach(function(s) {
      s.hidden = false;
      s.style.scrollSnapAlign = 'start';
      s.style.flexShrink = '0';
      s.style.width = '100%';
    });

    var currentIndex = 0;

    function goTo(index) {
      var slideWidth = slidesContainer.offsetWidth;
      slidesContainer.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
      currentIndex = index;
      // Update dots after scroll settles — avoids desync when iOS scroll-snap fights smooth scroll
      setTimeout(function() {
        var actualIndex = Math.round(slidesContainer.scrollLeft / slideWidth);
        dots.forEach(function(d, i) {
          d.classList.toggle('card-gallery__dot--active', i === actualIndex);
        });
        currentIndex = actualIndex;
      }, 350);
    }

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        goTo(i);
      });
    });

    var touchStartX = 0;
    var touchStartY = 0;
    var isHorizontal = null;

    gallery.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
      isHorizontal = null;
    }, { passive: true });

    gallery.addEventListener('touchmove', function(e) {
      if (isHorizontal === null) {
        var dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
        var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
        if (dx > 5 || dy > 5) {
          isHorizontal = dx > dy;
        }
      }
      if (isHorizontal) {
        e.preventDefault();
      }
    }, { passive: false });

    gallery.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      if (isHorizontal) {
        if (diff > 0 && currentIndex < 1) goTo(1);
        if (diff < 0 && currentIndex > 0) goTo(0);
      }
    }, { passive: true });
  }

  function initExisting() {
    document.querySelectorAll('.card-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initExisting);
  } else {
    initExisting();
  }

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('card-gallery')) {
          initGallery(node);
        }
        node.querySelectorAll && node.querySelectorAll('.card-gallery').forEach(initGallery);
      });
    });
  });

  function startObserver() {
    var grid = document.querySelector('.product-grid');
    observer.observe(grid || document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }
})();
